/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_MonthInputs */

const en_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month`)
};

const fr_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois`)
};

const de_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const it_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese`)
};

const ru_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месяц`)
};

const es_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes`)
};

const zh_cn2_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月`)
};

const ja_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月`)
};

const hi_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`महीना`)
};

const pt_pt2_usage_month = /** @type {(inputs: Usage_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês`)
};

/**
* | output |
* | --- |
* | "Month" |
*
* @param {Usage_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_month = /** @type {((inputs?: Usage_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_month(inputs)
	if (locale === "de") return de_usage_month(inputs)
	if (locale === "it") return it_usage_month(inputs)
	if (locale === "ru") return ru_usage_month(inputs)
	if (locale === "es") return es_usage_month(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_month(inputs)
	if (locale === "ja") return ja_usage_month(inputs)
	if (locale === "hi") return hi_usage_month(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_month(inputs)
	return en_usage_month(inputs)
});